<template>
  <el-collapse>
    <el-collapse-item class="sub-schema" :title="title">
      <schema-table ref="table"
                    :schema="spec.schema"
                    :initialFilter="filter"
                    :embedded="true"
                    @dataChanged="dataChanged"></schema-table>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
  import {assign, get} from 'lodash';
  import mixin from './mixin';
  import Table from '../../Tables/SchemaBaseTable.vue';
  import {Collapse, CollapseItem} from 'element-ui';
  import {findKeyField} from 'src/schemas/utils';

  export default {
    name: 'f-table',
    mixins: [mixin],
    components: {
      'schema-table': Table,
      [Collapse.name]: Collapse,
      [CollapseItem.name]: CollapseItem,
    },
    data() {
      return {
        title: '',
      };
    },
    computed: {
      filter() {
        if (typeof this.spec.initialFilter === 'function') {
          return this.spec.initialFilter.call(this, this.value, this.model);
        } else {
          return this.spec.initialFilter;
        }
      },
    },
    methods: {
      dataChanged(data, total) {
        this.title = `(${total})`;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// f-table.vue?38699f03